import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TransportInterventionsPageRequest} from '../transport-interventions-page/transport-interventions-page-request';
import {
  TransportIntervention,
  TransportInterventionPoi,
  TransportInterventionPoiGroupReport,
  transportInterventionPoiDiffAndGroupReport
} from 'shared';
import {TransportInterventionService} from '../../stores/transport-intervention.service';
import {Subject} from 'rxjs';

@Component({
  selector: 'app-transport-interventions-report',
  templateUrl: './transport-interventions-report.component.html',
  styleUrls: ['./transport-interventions-report.component.scss']
})
export class TransportInterventionsReportComponent implements OnInit {

  @Input()
  request: TransportInterventionsPageRequest;

  @Input()
  visible: boolean;

  @Output()
  visibleChange = new EventEmitter<boolean>();

  private _closeSubject = new Subject<void>();
  closed$ = this._closeSubject.asObservable();

  @Input()
  intervention: TransportIntervention;
  title: string;
  selectedTab: any;
  selectedIndex = 0;
  tabs: any;
  tabsLoading = {};
  loadingVisible: boolean;
  poiList: TransportInterventionPoi[];
  poiListGroupReport: TransportInterventionPoiGroupReport[];

  constructor(
    private transportInterventionService: TransportInterventionService,
  ) {
    this.close = this.close.bind(this);
    this.selectTab = this.selectTab.bind(this);
  }

  async ngOnInit() {

    this.tabs = [
      {
        id: 1,
        text: 'Rapport',
        load: (data) => {
        }
      },
      {
        id: 2,
        text: 'Details',
        load: (data) => {
        }
      },
      {
        id: 3,
        text: 'La Carte',
        load: (data) => {
        }
      }/*,
      {
        id: 4,
        text: 'Carburant',
        load: (data) => {
        }
      }*/];
  }

  closed(e: any) {
    this.visibleChange.emit(false);
    this.tabsLoading = {};
    this.selectedIndex = 0;
    this._closeSubject.next();
  }

  async onShowing(e: any) {

    await this.transportInterventionService.poiList(this.intervention.id).subscribe(list => {
      this.poiList = list.data as TransportInterventionPoi[];
      this.poiListGroupReport = transportInterventionPoiDiffAndGroupReport(this.poiList);
    });
  }

  onShown(e: any) {
    this.title = `Rapport d'Intervention`;
  }

  close() {
    this.visible = false;
  }

  async selectTab(e: any) {
    // Call load function for tab
    if (e.itemData.hasOwnProperty('load') && !this.tabsLoading.hasOwnProperty(e.itemData.id)) {
      this.loadingVisible = true;
      await e.itemData.load(e.itemData);
      this.loadingVisible = false;
      this.tabsLoading[e.itemData.id] = true;
    }

    this.selectedTab = e.itemIndex;
  }

}
